<p>base-list-with-entity-pictures works!</p>
